import {
    IF3BusAgentDTO,
    IF3BusAgentsRequestDTO,
    IF3BusDetailsRequestDTO,
    IF3BusRegisterRequestDTO,
} from "../../coreapi-dto/service/f3BusCore";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "../dirs/baseDirRequest";

export class F3BusCoreRequest extends BaseDirRequest<IF3BusAgentDTO, IF3BusAgentDTO> {
    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "ExtSources/F3Bus/Core", token, eventHandler);
    }

    agents(body: IF3BusAgentsRequestDTO, callback?: (e: CoreApiResponse<IF3BusAgentDTO[]>) => void) {
        this.post<IF3BusAgentDTO[]>(
            `${this._baseUrl}/${this._routePrefix}/Agents`,
            body,
            this.getHeaders(),
            (e) => this.handleResponse(e, callback),
        );
    }

    register(body: IF3BusRegisterRequestDTO, callback?: (e: CoreApiResponse<null>) => void) {
        this.post2<null>(
            `${this._baseUrl}/${this._routePrefix}/Register`,
            body,
            this.getHeaders(),
            (e) => this.handleResponse(e, callback),
        );
    }

    details(callback?: (e: CoreApiResponse<IF3BusDetailsRequestDTO>) => void) {
        this.post<IF3BusDetailsRequestDTO>(
            `${this._baseUrl}/${this._routePrefix}/Details`,
            null,
            this.getHeaders(),
            (e) => this.handleResponse(e, callback),
        );
    }

    private getHeaders(): string[][] {
        return this.concatHeaders(
            [this.getBearerHeader(this._token)],
            [ContentType.ApplicationJson],
        );
    }

    private handleResponse<T>(e: CoreApiResponse<T>, callback?: (e: CoreApiResponse<T>) => void) {
        if (e.respType === "isFailed") {
            this._eventHandler?.onGetResponse(e);
        }

        callback?.(e);
    }
}

export default F3BusCoreRequest;
